const brand = {
  name: "CMV Vision",
  short: "CMV",
  legal: "CMV Vision",
  domain: "cmvvision.com",
  oneLiner: "We turn brand momentum into measurable growth.",
  pitch:
    "CMV Vision is a digital marketing studio. We design the strategy, run the channels, ship the content and measure what actually moved — for brands that want growth they can trace, not just activity they can applaud.",
  contact: {
    email: "info@cmvvision.com",
    hours: "Mon — Fri · 09:00 — 18:00"
  },
  hq: {
    city: "Tiranë",
    country: "Albania",
    address: {
      line1: "Rruga Xhanfize Keko",
      line2: "Kompleksi Erli, Godina 1, shkalla 1, kati 2, Ap. 5 · Tiranë, Albania"
    }
  },
  metrics: [
    { value: "+182%", label: "Average lift in qualified pipeline · Year-1 engagements" },
    { value: "9", label: "Capabilities under one accountable team" },
    { value: "24", label: "Active brands across DACH, Balkans, Middle East" },
    { value: "100%", label: "Reporting on incremental contribution, not vanity" }
  ],
  proofPoints: [
    "Senior strategists on every account — no junior pass-through",
    "Full stack: strategy, brand, content, paid, SEO, analytics",
    "Bilingual delivery: English + local language for every market",
    "Quarterly business reviews with measurable, contracted outcomes"
  ]
};

export default brand;
